import "@chakra-ui/react";
import { ThemeColorVariable as o } from "../../theme/theme-types.js";
const r = "label[data-checked]:not(:active):not([data-disabled]):hover", e = "label:not([data-checked]):not(:active):not([data-disabled]):not([data-invalid]):hover", a = "label[data-invalid]:not([data-checked]):hover", l = {
  // Target only device that supports hover (excludes thouch screen devices):
  "@media(hover: hover)": {
    // General cursor styles
    "label:not([data-disabled]):hover": {
      cursor: "pointer"
    },
    "label[data-disabled]:hover": {
      cursor: "not-allowed"
    },
    // Specifc state hover styles
    [r]: {
      ".chakra-radio__control": {
        bg: o.AccentHover,
        borderColor: o.AccentHover,
        color: o.OnAccent
      }
    },
    [e]: {
      ".chakra-radio__control": {
        borderColor: o.AccentHover,
        color: o.OnSurface
      }
    },
    [a]: {
      ".chakra-radio__control": {
        color: o.ErrorHover,
        borderColor: o.ErrorHover
      }
    }
  }
}, d = {
  // Target only device that supports hover (excludes thouch screen devices):
  "@media(hover: hover)": {
    // General cursor styles
    "label:not([data-disabled]):hover": {
      cursor: "pointer"
    },
    "label[data-disabled]:hover": {
      cursor: "not-allowed"
    },
    // Specifc state hover styles
    [r]: {
      ".chakra-radio__control": {
        bg: o.AccentHover,
        borderColor: o.AccentHover,
        color: o.OnAccent
      }
    },
    [e]: {
      ".chakra-radio__control": {
        color: o.OnSurface,
        background: o.AccentHoverAlpha
      }
    },
    [a]: {
      ".chakra-radio__control": {
        color: o.ErrorHover,
        borderColor: o.ErrorHover
      }
    }
  }
};
export {
  l as hoverStyles,
  d as hoverStylesCard
};
